import React, { Component } from 'react'
import styled from 'styled-components'
import { Modal, TextInput, Button, DatePicker, SelectSearch } from 'advenio-components'
import { Form } from 'formsy-react' //eslint-disable-line

import TimePicker from '../../TimePicker/TimePicker'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  overflow: scroll;
  @media (min-width: 375px) {
    overflow: visible;
  }
`
const InputContainer = styled.div`
  margin: 0 8px;
  flex: 1;
  ${({ datePicker }) => datePicker && `
    flex: 2;
    margin: 0 0 0px 8px;
  `}
`
const InputRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  flex: 1 1;
  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }
`

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
class MedicineModal extends Component {
  state = {
    width: window.innerWidth,
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions = () => {
    const width = window.innerWidth
    this.setState({ width })
  }

  handleSubmit = ({ medicine_date, comments, dose, name, student }) => {
    const student_id = this.props.studentId
    let newInfo = null
    const newDate = this.timepicker.getValue()
    if (this.props.fromCenter) {
      newInfo = {
        from_date: medicine_date.start_date,
        to_date: medicine_date.end_date,
        student_id: student,
        comments,
        dose,
        name,
        apply_at: newDate,
      }
    } else {
      newInfo = {
        from_date: medicine_date.start_date,
        to_date: medicine_date.end_date,
        student_id,
        comments,
        dose,
        name,
        apply_at: newDate,
      }
    }
    this.props.createMedicine(newInfo)
  }

  renderForm = desktop => (
    <Form onSubmit={this.handleSubmit}>
      {this.props.fromCenter &&
      <InputRow>
        <InputContainer>
          <SelectSearch
            name="student"
            label="Alumno"
            hideEmptyHelpBlock={false}
            options={this.props.students}
            validationErrors={{}}
          />
        </InputContainer>
        <InputContainer />
      </InputRow>
      }
      <InputRow>
        <InputContainer>
          <TextInput
            name="name"
            label="Medicamento"
            hideEmptyHelpBlock
          />
        </InputContainer>
        <InputContainer>
          <TextInput
            name="dose"
            label="Dosis"
            hideEmptyHelpBlock
          />
        </InputContainer>
      </InputRow>
      <InputRow>
        <InputContainer datePicker>
          <DatePicker
            name="medicine_date"
            startLabel="Fecha de inicio"
            endLabel="Fecha de termino"
            marginBetweenFields="8px"
            pickerType="range"
            hideEmptyHelpBlock
            disableBeforeToday
            numberOfMonths={desktop ? 2 : 1}
          />
        </InputContainer>
      </InputRow>
      <InputRow>
        <InputContainer>
          <TimePicker
            name="apply_at"
            label="Hora"
            hideEmptyHelpBlock
            ref={(timepicker) => { this.timepicker = timepicker }}
          />
        </InputContainer>
      </InputRow>
      <InputContainer>
        <TextInput
          name="comments"
          label="Comentarios"
          textarea
          hideEmptyHelpBlock
        />
      </InputContainer>
      <ButtonRow>
        <Button
          success
          type="submit"
          loading={this.props.loading}
        >
          Guardar
        </Button>
      </ButtonRow>
    </Form>
  )

  render() {
    const { width } = this.state
    return (
      <Modal
        isOpened={this.props.open}
        headerTitle="Medicamento"
        onClose={this.props.onClose}
        full={width <= 767}
        allowOverflow
        statePath="parent_platform_medicine"
        actionType="medicine"
        typePrefix="PARENT_PLATFORM_MEDICINE"
      >
        <Container>
          {this.renderForm(width <= 767)}
        </Container>
      </Modal>
    )
  }
}

export default MedicineModal



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/MedicineModal/index.jsx